import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE } from "../lib/api";
import axios from "axios";
import { Sparkles, ImageIcon } from "lucide-react";

export default function PublicPortfolioPage() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE}/public/portfolio/${slug}`)
      .then((r) => setItem(r.data))
      .catch(() => setError("Bu paylaşım bulunamadı veya kaldırılmış."));
  }, [slug]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-950 text-neutral-100">
        <div className="text-center">
          <div className="text-2xl font-display font-semibold">404</div>
          <div className="text-sm text-neutral-400 mt-2">{error}</div>
        </div>
      </div>
    );
  }
  if (!item) return <div className="min-h-screen flex items-center justify-center bg-neutral-950 text-neutral-100">Yükleniyor...</div>;

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100">
      <header className="sticky top-0 z-10 border-b border-neutral-800 bg-neutral-950/70 backdrop-blur-xl">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-md bg-white flex items-center justify-center">
              <Sparkles className="h-4 w-4 text-neutral-950" />
            </div>
            <div>
              <div className="text-sm font-display font-semibold">SwayDesign</div>
              <div className="text-[10px] uppercase tracking-widest text-neutral-400">Portföy Vitrini</div>
            </div>
          </div>
          <div className="text-xs text-neutral-400">{item.owner_name}</div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-16">
        <div className="text-[10px] uppercase tracking-widest text-neutral-400">{item.platform}</div>
        <h1 className="text-4xl sm:text-5xl font-display font-semibold tracking-tight mt-2">{item.title}</h1>
        {item.description && (
          <p className="mt-6 text-lg text-neutral-300 max-w-3xl leading-relaxed">{item.description}</p>
        )}

        <div className="mt-12 space-y-6">
          {item.images.length === 0 ? (
            <div className="rounded-xl border border-neutral-800 aspect-video flex items-center justify-center text-neutral-500">
              <ImageIcon className="h-10 w-10" />
            </div>
          ) : item.images.map((path, i) => (
            <div key={i} className="rounded-xl overflow-hidden border border-neutral-800 bg-neutral-900">
              <img
                src={`${API_BASE}/public/portfolio/image/${path}`}
                alt={`${item.title} ${i + 1}`}
                className="w-full h-auto"
                loading={i === 0 ? "eager" : "lazy"}
              />
            </div>
          ))}
        </div>

        <footer className="mt-24 pt-8 border-t border-neutral-800 text-center">
          <div className="text-sm text-neutral-400">Bu iş <span className="text-neutral-200 font-medium">{item.owner_name}</span> tarafından hazırlandı.</div>
          <div className="mt-2 text-xs text-neutral-500">SwayDesign · Grafik Tasarım</div>
        </footer>
      </main>
    </div>
  );
}
